import { QuestionType } from "../types/questionType";
import { WELCOME_SMS_LABEL, WELCOME_SMS_ORDER } from "./index";

const isWelcome = (question?: Pick<QuestionType, "order" | "name">) => {
  return question?.order === WELCOME_SMS_ORDER && question?.name === WELCOME_SMS_LABEL;
};

export default isWelcome;
